import React from 'react';
import { KanaTable } from './KanaTable';
import { UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  routeNumList: {
    bankInitials: number,
    bankSelect: number,
    branchInitials: number,
    branchSelect: number
  },
  setRouteNum: React.Dispatch<React.SetStateAction<number>>,
  onUpdateInitial: (label: 'bank' | 'branch') => void,
  register: UseFormRegister<BankAccountFormData>
}

export const BranchNameInitials = (props: Props) => {
  const { routeNumList, setRouteNum, onUpdateInitial, register } = props;
  const fieldLabel = 'branch';

  return (
    <>
      <div className="bank-account">
        <div className="bank-account__heading">
          支店の選択
        </div>
        <div className="bank-account__lead">
          支店名の頭文字を選択してください。
        </div>
        <div className="bank-account__initial">
          <KanaTable register={register} fieldLabel={fieldLabel} />
          <span className="form-input__error"></span>
        </div>
        <div className="bank-account__note">
          <p className="bank-account__note-text">英語表記の支店の場合は、五十音を選択せずに「次へ進む」をクリックすると支店の一覧が表示されます</p>
        </div>
        <div className="layout-flex--center bank-account__button-layout">
          <div className="is-pc">
            <button onClick={() => setRouteNum(routeNumList.bankSelect)} className="button-base--sub button-w182 mr16">
              前の入力へ戻る
            </button>
          </div>
          <button onClick={() => onUpdateInitial(fieldLabel)} type="button" className="button-base--action button-w344">
            次へ進む
            <i className="material-icons button-icon-right flip-horizontal">keyboard_backspace</i>
          </button>
        </div>
      </div>
    </>
  );
};
